$('.scroll').click(function(){
  const anchor = $(this).attr('href');
  const tag = (anchor == '#') ? $('body') : $(anchor);
  $('html,body').animate({scrollTop: tag.offset().top}, 'slow');
  return false;
});